// Synthetic account types — demo/test logins that exist to demonstrate or
// exercise the product rather than being someone's real working account. They
// never hold implicit staff access or the /admin capability. Mirrors the
// backend `SYNTHETIC_ACCOUNT_TYPES` in apps/api/src/utils/auth.py and
// firebase/functions/src/shared/auth.ts — the three runtimes decide the same
// question and must answer it the same way.
export const SYNTHETIC_ACCOUNT_TYPES = ["demo", "test"];

/** Whether an `account_type` marks a synthetic (demo/test) account. */
export function isSyntheticAccountType(accountType) {
  return SYNTHETIC_ACCOUNT_TYPES.includes(accountType);
}
